export const propertiesToResetOnPageView = [
    "SegmentComparison_ID",
    "Segment_ID",
    "domains_amount",
    "segments_amount",
    "predef_segments_amount",
    "Segment_Domain",
    "Segment_Name",
    "Segment_Type",
    "Segment_Sector",
    "entities_amount",
    "compare_mode",
    "date_range_mode",
    "max_history",
    "KW_list_type",
    "KW_list_ID",
    "KW_list_name",
    "KW_list_num_keywords",
    "KW_list_shared_with_me",
    "Clusters",
    "Topic_level",
    "is_asset_owner",
    "asset_type",
    "asset_name",
    "asset_id",
    "entity_type",
    "entity_name",
    "entity_id",
    "num_of_entities",
    "number_of_keywords_in_campaign",
    "number_of_searchEngines_in_campaign",
    "number_of_competitors_in_campaign",
    "source",
];
